import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { Translate } from 'react-redux-i18n'
import EventEmitter, { DID_MOUNT_COMPONENT } from '../../helpers/EventEmitter'
import { Element } from '../html/element'
import { Icon } from '../html/icon'
import classes from './index.module.scss'

export const Notification = ({
  value,
  isI18n,
  isItalic,
  style,
  isDynamicReport,
  customContent,
}) => {
  useEffect(() => {
    EventEmitter.dispatch(DID_MOUNT_COMPONENT)
  }, [])

  if (isDynamicReport) {
    return (
      <Element
        style={{
          color: '#9C9C9C',
          fontSize: 12,
          ...style,
        }}
        className="pl2 w100"
      >
        <Translate value="common.NO_DATA" />
      </Element>
    )
  }

  return (
    <div className={classes.container} style={{ ...style }}>
      <Icon
        className="icon-info-circle"
        style={{ fontSize: 30, color: '#9C9C9C' }}
      />
      {!!customContent ? (
        customContent()
      ) : (
        <Element
          elementName="span"
          style={{
            color: '#9C9C9C',
            fontStyle: isItalic ? 'italic' : 'normal',
            ...style,
          }}
        >
          {isI18n ? <Translate value={value} /> : value}
        </Element>
      )}
    </div>
  )
}

Notification.propTypes = {
  value: PropTypes.any,
  isI18n: PropTypes.bool,
  isItalic: PropTypes.bool,
  style: PropTypes.object,
  isDynamicReport: PropTypes.bool,
  customContent: PropTypes.func,
}

Notification.defaultProps = {
  value: 'common.NO_DATA',
  isI18n: true,
  isItalic: true,
  style: {},
  isDynamicReport: false,
}
